/**
 * Ob das Fenster mindestens so breit ist wie der Zeiger-Breakpoint (768px,
 * `tokens.css`/Tailwind `md:`).
 *
 * Nicht per CSS allein: Sidebar (`AppShell`) und die volle Baumliste im
 * Bildschirm *Objekte* zeigen **denselben** Baum, aber nie beide gleichzeitig
 * (Spec 01, „Der Baum"). Zwei mit `hidden md:block` nur optisch versteckte
 * Kopien stünden trotzdem beide im Dokument — mit denselben
 * `data-testid`-Werten doppelt, und `property-add` wäre kein eindeutiges Ziel
 * mehr (AK-41). Diese Funktion entscheidet deshalb in JavaScript, **welche**
 * der beiden Stellen den Baum überhaupt mountet.
 */

import { useSyncExternalStore } from 'react'

const QUERY = '(min-width: 768px)'

function subscribe(onChange: () => void): () => void {
  const mediaQueryList = window.matchMedia(QUERY)
  mediaQueryList.addEventListener('change', onChange)
  return () => {
    mediaQueryList.removeEventListener('change', onChange)
  }
}

function getSnapshot(): boolean {
  return window.matchMedia(QUERY).matches
}

export function useIsDesktopViewport(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => true)
}
